import { render, staticRenderFns } from "./contentLabelInfo.vue?vue&type=template&id=38d031a4&scoped=true"
import script from "./contentLabelInfo.vue?vue&type=script&lang=js"
export * from "./contentLabelInfo.vue?vue&type=script&lang=js"
import style0 from "./contentLabelInfo.vue?vue&type=style&index=0&id=38d031a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d031a4",
  null
  
)

export default component.exports